module.exports = __webpack_public_path__ + "static/media/Queens-Roll.44cd1987.png";